export default {
  path: 'reports',
  name: 'orders.reports',
  component: () => import('@/views/admin/orders/default/reports/Index'),
}